import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: null | string = null

export const cifSlice = createSlice({
  name: 'cif',
  initialState,
  reducers: {
    setCif: (state, action: PayloadAction<string>) => action.payload,
  },
})

export const { setCif } = cifSlice.actions

export default cifSlice.reducer
